import { getCookie, type OptionsType } from 'cookies-next/client';

// pass {req,res} as context when using server-side
export const getUserId = (context?: OptionsType) =>
  getCookie('user_id', context);

export const isLoggedIn = (context?: OptionsType) =>
  getUserId(context) !== undefined;
